var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 0.809326C3.82495 0.809326 0.449951 4.18433 0.449951 8.35933C0.449951 12.5343 3.82495 15.9343 7.99995 15.9343C12.175 15.9343 15.575 12.5343 15.575 8.35933C15.575 4.18433 12.175 0.809326 7.99995 0.809326ZM7.99995 14.8093C4.44995 14.8093 1.57495 11.9093 1.57495 8.35933C1.57495 4.80933 4.44995 1.93433 7.99995 1.93433C11.55 1.93433 14.45 4.83433 14.45 8.38433C14.45 11.9093 11.55 14.8093 7.99995 14.8093Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2999 6.03435C10.0749 5.80935 9.72485 5.80935 9.49985 6.03435L7.99985 7.55935L6.47485 6.03435C6.24985 5.80935 5.89985 5.80935 5.67485 6.03435C5.44985 6.25935 5.44985 6.60935 5.67485 6.83435L7.19985 8.35935L5.67485 9.88435C5.44985 10.1093 5.44985 10.4593 5.67485 10.6843C5.77485 10.7843 5.92485 10.8593 6.07485 10.8593C6.22485 10.8593 6.37485 10.8093 6.47485 10.6843L7.99985 9.15935L9.52485 10.6843C9.62485 10.7843 9.77485 10.8593 9.92485 10.8593C10.0749 10.8593 10.2249 10.8093 10.3249 10.6843C10.5499 10.4593 10.5499 10.1093 10.3249 9.88435L8.79985 8.35935L10.3249 6.83435C10.5249 6.60935 10.5249 6.25935 10.2999 6.03435Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg49);
export default __webpack_public_path__ + "static/media/svg49.bfb6057dbb743d95d5184609330462b4.svg";
export { ForwardRef as ReactComponent };